module.exports = __webpack_public_path__ + "img/search.141d172b.svg";